import { render } from "./ProductCreatePage.vue?vue&type=template&id=f72d8e34"
import script from "./ProductCreatePage.vue?vue&type=script&lang=js"
export * from "./ProductCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__